<div class="ostso-dialog landmark">
  <div class="header">
    <button mat-icon-button class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
    <h1>{{ isNew ? "Создание значения индексов ИАС Спорт" : "Редактирование значения индексов ИАС Спорт" }}</h1>

  </div>
  <div mat-dialog-content>
    <form class="form" [formGroup]="form">
      <pas-multi-select3 [formControlName]="'index'"
                         title="Индекс ИАС Спорт"
                         [customDataService]="indexEntityService"
                         customDialogMethod="apiIndexGet"
                         type="radio"
                         [options]="{pageSize: 1e6, fillTypes: ['Ias_Sport']}"
      >
        <ng-template #listItem let-item>
          {{ item.name }}
        </ng-template>
        <ng-template #dialogList let-item>
          {{ item.name }} ({{ item.shortName }}), (ID: {{ item.id }})
        </ng-template>
      </pas-multi-select3>

      <pas-multi-select3 [formControlName]="'organization'"
                         title="Учреждение"
                         [customDataService]="organizationService"
                         customDialogMethod="apiOrganizationFilterlistGet"
                         type="radio"
                         [options]="{pageSize: 1e6}"
      >
        <ng-template #listItem let-item>
          {{ item.name }}
        </ng-template>
      </pas-multi-select3>

      <pas-choise title="Тип оценки" [items]="periods" [formControlName]="'period'">
        <ng-template #name let-item>
          {{ item.name }}
        </ng-template>
      </pas-choise>

        <pas-choise title="Выбор года" [items]="years" [formControlName]="'year'">
          <ng-template #name let-item>
            {{ item.name }}
          </ng-template>
        </pas-choise>

      @if (period && period.name === "Квартальная") {

        <pas-choise title="Выбор квартала" [items]="quarters" [formControlName]="'quarter'">
          <ng-template #name let-item>
            {{ item.name }} квартал
          </ng-template>
        </pas-choise>
      }

      <mat-expansion-panel [expanded]="true" class="mat-elevation-z0"
                           [style]="{'background-color': '#F3F4F6'}">
        <mat-expansion-panel-header>Ввод значения</mat-expansion-panel-header>
        <mat-form-field>
          <input matInput [formControlName]="'value'" type="number">
        </mat-form-field>
      </mat-expansion-panel>

      <br/>

    </form>
  </div>
  <div mat-dialog-actions>
    <button class="btn btn-blue" mat-button cdkFocusInitial (click)="onApply()" [disabled]="!form.valid">Применить</button>
    <button class="btn btn-secondary" mat-button (click)="onNoClick()">Сбросить</button>
  </div>
</div>

